import { getProbeDetails, postMultipleDirectorDetails } from "../../../services/httpCalls"

export const getDirectorsProbe = async ({
    notify,
    Cookies,
    directors_,
    setShowLoader,
    postDataArray,
    setDirectors,
    refreshDirectors,
    setRefreshDirectors
}) => {
    let orgId = localStorage.getItem("orgId")

    let pan = Cookies.get("pan")

    if (pan) {
      setShowLoader(true)

      await getProbeDetails(pan)
        .then(async res => {
          if (res.directors) {
            if (res.directors.length && postDataArray.length === 0) {
                res.directors?.forEach(value => {
                
                let firstName = value?.name?.split(' ')[0];
                let lastName = value?.name?.slice(firstName.length).trim();

                let postdataEach = {
                  status: "ACTIVE",
                  name: value?.name ? value?.name : null,
                  firstName: firstName ? firstName : null,
                  lastName: lastName ? lastName : null,
                  dateOfAppointment: null,
                  din: value?.din ? value?.din : null,
                  emailId: value?.emailId ? value?.emailId : null,
                  panNumber: value?.panNumber ? value?.panNumber : null,
                  nationality: value?.nationality
                    ? value?.nationality === "IN"
                      ? "Indian"
                      : null
                    : null,
                  address: null,
                  docs: null
                }
                postDataArray.push(postdataEach)
              })

              if (directors_.length === 0 && postDataArray.length) {
                await postMultipleDirectorDetails(postDataArray, orgId)
                  .then(response => {
                    if (response !== undefined) {
                      if (response?.length) {
                        setDirectors(response)
                        directors_ = response
                      }
                    } else {
                      notify.error("Error saving directors data!")
                    }
                  })
                  .catch(err => {
                    notify.error("Error saving directors data!")
                  })
                  .finally(() => setRefreshDirectors(!refreshDirectors))
              }
            }
          }
        })
        .catch(() => notify.error("Please add the director!"))
        .finally(() => {
          setShowLoader(false)
        })
    }
  }